var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "DropdownInput"
  }, [_c('button', {
    staticClass: "DropdownInput-button d-flex align-items-center justify-content-between",
    attrs: {
      "id": ("js-dropdown-input-" + (_vm.inputId)),
      "aria-expanded": _vm.isOptionsOpen,
      "aria-haspopup": "listbox",
      "type": "button"
    },
    on: {
      "click": _vm.toggleOptions
    }
  }, [_c('div', {
    staticClass: "DropdownInput-label"
  }, [_vm._v(" " + _vm._s(_vm.label) + " "), _vm.isRequired ? _c('span', {
    staticClass: "DropdownInput-required"
  }, [_vm._v("*")]) : _vm._e()]), _vm.withSlotItem ? _vm._t("currentOption", null, {
    "item": _vm.items[_vm.value]
  }) : [_vm._v(" " + _vm._s(_vm.items[_vm.value]) + " ")], _c('span', {
    staticClass: "DropdownInput-iconContainer pl-3"
  }, [_c('chevron-micro-icon', {
    staticClass: "DropdownInput-icon",
    class: _vm.isOptionsOpen ? 'DropdownInput-icon--opened' : ''
  })], 1)], 2), _c('div', {
    staticClass: "DropdownInput-optionsContainer"
  }, [_c('input-options', {
    attrs: {
      "backgroundColorSelected": _vm.backgroundColorSelected,
      "colorSelected": _vm.colorSelected,
      "items": _vm.items,
      "isOptionsOpen": _vm.getIsOptionsOpen,
      "value": _vm.value,
      "withSlotItem": _vm.withSlotItem
    },
    on: {
      "input": _vm.optionChanged
    },
    scopedSlots: _vm._u([_vm._l(_vm.$scopedSlots, function (_, slot) {
      return {
        key: slot,
        fn: function (props) {
          return [_vm._t(slot, null, null, props)];
        }
      };
    })], null, true)
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }